import React from "react";
import {
    ButtonProps,
    ButtonRenderProps,
    ClearFiltersButton,
    ContentSection,
    createListTableColumns,
    Grid,
    GridColumn,
    GridRow,
    ListTable,
    renderDateTime,
    SearchBox,
    Stack
} from "sprint-common-web";

import { AddManzanitaPresetButton } from "./buttons/AddManzanitaPresetButton";
import { EditManzanitaPresetButton } from "./buttons/EditManzanitaPresetButton";
import { ManzanitaPresetPreviewButton } from "./buttons/ManzanitaPresetPreviewButton";
import { ManzanitaPresetListingItem } from "./ManzanitaPresetListingItem";
import { useManzanitaPresetListing } from "./useManzanitaPresetListing";
import { useManzanitaPresetListingFilters } from "./useManzanitaPresetListingFilters";

export const ManzanitaPresetListing: React.VFC = () => {
    const { setName, setSort, clearFilters, filters } = useManzanitaPresetListingFilters();
    const { listingItems, isLoading } = useManzanitaPresetListing(filters);

    const columns = createListTableColumns<ManzanitaPresetListingItem>([
        {
            type: "basic",
            key: "name",
            name: "Name",
            minWidth: 50,
            maxWidth: 100,
            isSortable: true
        },
        {
            type: "basic",
            key: "updatedDate",
            name: "Updated",
            minWidth: 100,
            maxWidth: 150,
            onRender: renderDateTime,
            isSortable: true
        },
        {
            type: "buttons",
            key: "actions",
            name: "Actions",
            minWidth: 177,
            maxWidth: 177,
            isResizable: false,
            buttons: [
                {
                    id: "presetPreview",
                    render: ManzanitaPresetPreviewButton
                },
                {
                    id: "editPreset",
                    render: EditManzanitaPresetButton
                }
            ]
        }
    ]);
    const addManzanitaPresetButtonProps: ButtonRenderProps<ButtonProps> = {
        render: AddManzanitaPresetButton
    };
    return (
        <ContentSection header="Presets" buttons={[addManzanitaPresetButtonProps]}>
            <Grid>
                <GridRow>
                    <GridColumn sm={3}>
                        <SearchBox placeholder="Name" onChange={setName} value={filters.name} />
                    </GridColumn>
                    <GridColumn sm={9}>
                        <Stack horizontalAlign="end">
                            <ClearFiltersButton onClear={clearFilters} isLabeled={true} />
                        </Stack>
                    </GridColumn>
                </GridRow>
                <GridRow>
                    <GridColumn sm={12}>
                        <ListTable
                            columns={columns}
                            items={listingItems}
                            sort={{ by: filters.sortBy, order: filters.sortOrder }}
                            onSortChange={setSort}
                            isLoading={isLoading}
                        />
                    </GridColumn>
                </GridRow>
            </Grid>
        </ContentSection>
    );
};
